import { Component } from "@angular/core";
import { EceButtonComponent } from "./ece.button.component";

@Component({
    selector: "ece-btn-primary",
    templateUrl: "./ece.button.component.html",
    standalone: false
})
export class PrimaryButtonComponent extends EceButtonComponent {
  primary = true;
}
